import createSvgIcon from "./utils/create_icon"

const RotateLeft = createSvgIcon(<path d="M11.707 3.707a1 1 0 0 0-1.414-1.414l-3 3a1 1 0 0 0 0 1.414l3 3a1 1 0 0 0 1.414-1.414L10.414 7H12a6 6 0 1 1-6 6 1 1 0 1 0-2 0 8 8 0 1 0 8-8h-1.586l1.293-1.293Z" fill="currentColor" />, "RotateLeft")
export default RotateLeft
